// Manages the referral code persisted from ?ref= URL param across navigations.
const KEY = "folio_ref_code";

export function captureRefFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref && /^[A-Z0-9]{8}$/i.test(ref)) {
      localStorage.setItem(KEY, ref.toUpperCase());
      return ref.toUpperCase();
    }
  } catch (err) {
    console.warn("[referral] cannot read ?ref param:", err);
  }
  try {
    return localStorage.getItem(KEY) || null;
  } catch (err) {
    console.warn("[referral] cannot read stored code:", err);
    return null;
  }
}

export function getRefCode() {
  try {
    return localStorage.getItem(KEY) || null;
  } catch (err) {
    console.warn("[referral] cannot read stored code:", err);
    return null;
  }
}

export function clearRefCode() {
  try {
    localStorage.removeItem(KEY);
  } catch (err) {
    console.warn("[referral] cannot clear stored code:", err);
  }
}
